"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const types_1 = require("@adaptabletools/adaptable/types");
const env_1 = tslib_1.__importDefault(require("./env"));
const package_json_1 = require("../package.json");
const version_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/version"));
const ModuleConstants = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Utilities/Constants/ModuleConstants"));
const ModuleConstants_1 = require("@adaptabletools/adaptable/src/Utilities/Constants/ModuleConstants");
const PopupRedux = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Redux/ActionsReducers/PopupRedux"));
const AdaptableViewFactory_1 = require("@adaptabletools/adaptable/src/View/AdaptableViewFactory");
const PushPullModule_1 = require("./Module/PushPullModule");
const IPushPullApiImpl_1 = require("./IPushPullApiImpl");
const PushPullService_1 = require("./Utilities/Services/PushPullService");
const ipushpull_js_1 = tslib_1.__importDefault(require("ipushpull-js"));
const IPushPullRedux_1 = require("./Redux/ActionReducers/IPushPullRedux");
const IPushPullLoginPopup_1 = require("./View/IPushPullLoginPopup");
const IPushPullAddPagePopup_1 = require("./View/IPushPullAddPagePopup");
const PluginsRedux_1 = require("@adaptabletools/adaptable/src/Redux/ActionsReducers/PluginsRedux");
const StringExtensions_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/Utilities/Extensions/StringExtensions"));
const IPushPullViewPanel_1 = require("./View/IPushPullViewPanel");
if (package_json_1.version !== version_1.default) {
    console.warn(`
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
!!!!!!! "@adaptabletools/adaptable-plugin-ipushpull" (v @${package_json_1.version}) and "@adaptabletools/adaptable" (v @${version_1.default}) have different versions - they should have the exact same version.
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
`);
}
const getApiKey = () => {
    let key = env_1.default.IPUSHPULL_API_KEY; // need to make sure that is always there
    return key;
};
const getApiSecret = () => {
    let secret = env_1.default.IPUSHPULL_API_SECRET; // need to make sure that is always there
    return secret;
};
const defaultOptions = {
    ippConfig: {
        api_secret: getApiSecret() || '',
        api_key: getApiKey() || '',
        api_url: 'https://www.ipushpull.com/api/1.0',
        ws_url: 'https://www.ipushpull.com',
        web_url: 'https://www.ipushpull.com',
        docs_url: 'https://docs.ipushpull.com',
        storage_prefix: 'ipp_local',
        transport: 'polling',
        hsts: false, // strict cors policy
    },
    autoLogin: false,
    throttleTime: 2000,
    includeSystemReports: true,
};
class IPushPullPlugin extends types_1.AdaptablePlugin {
    constructor(options) {
        super(options);
        this.pluginId = 'ipushpull';
        this.rootReducer = (rootReducer) => {
            return {
                System: (state, action) => {
                    let augmentedState = rootReducer.System(state, action);
                    if (!state) {
                        // required for store initialization
                        // (idiomatic way of default parameter value in reducer is not feasible because the passed argument is already initialized by the System reducer)
                        augmentedState = Object.assign({}, augmentedState, IPushPullRedux_1.iPushPullInitialState);
                    }
                    return (0, IPushPullRedux_1.IPushPullReducer)(augmentedState, action);
                },
            };
        };
        this.reduxMiddleware = (adaptable) => (middlewareAPI) => {
            return (next) => {
                return (action) => {
                    switch (action.type) {
                        case PluginsRedux_1.IPUSHPULL_LOGIN: {
                            const actionTyped = action;
                            this.iPushPullApi.loginToIPushPull(actionTyped.username, actionTyped.password);
                            return next(action);
                        }
                        case PluginsRedux_1.IPUSHPULL_SEND_SNAPSHOT: {
                            let iPushPullModule = (adaptable.adaptableModules.get(ModuleConstants.IPushPullModuleId));
                            const actionTyped = action;
                            iPushPullModule.sendSnapshot(actionTyped.iPushPullReport);
                            middlewareAPI.dispatch(PopupRedux.PopupHideScreen());
                            return next(action);
                        }
                        case PluginsRedux_1.IPUSHPULL_START_LIVE_DATA: {
                            let iPushPullModule = (adaptable.adaptableModules.get(ModuleConstants.IPushPullModuleId));
                            const actionTyped = action;
                            iPushPullModule.startLiveData(actionTyped.iPushPullReport);
                            middlewareAPI.dispatch(PopupRedux.PopupHideScreen());
                            return next(action);
                        }
                        case PluginsRedux_1.IPUSHPULL_STOP_LIVE_DATA: {
                            let iPushPullModule = (adaptable.adaptableModules.get(ModuleConstants.IPushPullModuleId));
                            iPushPullModule.stopLiveData();
                            return next(action);
                        }
                        case PluginsRedux_1.IPUSHPULL_ADD_PAGE: {
                            const actionTyped = action;
                            this.iPushPullApi.addNewIPushPullPage(actionTyped.folder, actionTyped.page);
                            return next(action);
                        }
                        case PluginsRedux_1.IPUSHPULL_SET_CURRENT_FOLDER: {
                            const actionTyped = action;
                            const currentFolder = actionTyped.folder;
                            const isFolderValid = StringExtensions_1.default.IsNotNullOrEmpty(currentFolder);
                            const availablePages = isFolderValid
                                ? adaptable.api.pluginsApi
                                    .getipushpullPluginApi()
                                    .getPagesForIPushPullDomain(currentFolder)
                                : [];
                            middlewareAPI.dispatch((0, IPushPullRedux_1.IPushPullSetCurrentAvailablePages)(availablePages));
                            middlewareAPI.dispatch((0, IPushPullRedux_1.IPushPullSetCurrentPage)(''));
                            return next(action);
                        }
                        case PluginsRedux_1.IPUSHPULL_DOMAIN_PAGES_SET: {
                            //refresh the available pages
                            const currentFolder = middlewareAPI.getState().System.IPushPullCurrentFolder;
                            const isFolderValid = StringExtensions_1.default.IsNotNullOrEmpty(currentFolder);
                            if (isFolderValid) {
                                const availablePages = adaptable.api.pluginsApi
                                    .getipushpullPluginApi()
                                    .getPagesForIPushPullDomain(currentFolder);
                                middlewareAPI.dispatch((0, IPushPullRedux_1.IPushPullSetCurrentAvailablePages)(availablePages));
                            }
                            return next(action);
                        }
                        default: {
                            return next(action);
                        }
                    }
                };
            };
        };
        const ippConfig = Object.assign(Object.assign({}, defaultOptions.ippConfig), (options || {}).ippConfig);
        if (!ippConfig.api_key) {
            ippConfig.api_key = defaultOptions.ippConfig.api_key;
        }
        if (!ippConfig.api_secret) {
            ippConfig.api_secret = defaultOptions.ippConfig.api_secret;
        }
        this.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), options), { ippConfig });
        /**
         * Contains the objects required to export (snapshot or live) data to ipushpull from AdapTable.
         *
         * Includes ipushpull config and objects and, optionally, any ipushpull Reports (including schedules).
         */
        // IPushPull?: IPushPullState;
        ipushpull_js_1.default.config.set(this.options.ippConfig);
    }
    afterInitApi(adaptable) {
        this.iPushPullApi = new IPushPullApiImpl_1.IPushPullApiImpl(adaptable, this.options);
        this.PushPullService = new PushPullService_1.PushPullService(adaptable);
        this.iPushPullApi.setIPushPullInstance(ipushpull_js_1.default);
        this.registerProperty('api', () => this.iPushPullApi);
        this.registerProperty('service', () => this.PushPullService);
    }
    afterInitModules(adaptable, modules) {
        modules.set(ModuleConstants_1.IPushPullModuleId, new PushPullModule_1.PushPullModule(adaptable.api));
        AdaptableViewFactory_1.AdaptableViewFactory.IPushPullLoginPopup = IPushPullLoginPopup_1.IPushPullLoginPopup;
        AdaptableViewFactory_1.AdaptableViewFactory.IPushPullAddPagePopup = IPushPullAddPagePopup_1.IPushPullAddPagePopup;
        AdaptableViewFactory_1.AdaptableViewPanelFactory.set(ModuleConstants_1.IPushPullModuleId, IPushPullViewPanel_1.IPushPullViewPanelControl);
    }
}
exports.default = (options) => new IPushPullPlugin(options);
